import * as php from '../../php-compat';
import type { PortEnv } from '../../port-contract';
import { checkUuid } from '../../pl/contract';
import { phpAdd, phpSubtract } from '../../compile/php-integer-arithmetic';
import { PhpArray, array_key_last, empty, intval, phpCopy, strval, strtoupper, trim } from '../../php-compat';
import { array, entries, get, isArray, type ReadEnv, type Storage } from './shared';

/** PHP: janus_trigger_depth (includes/functions/janus/core/janus_trigger_depth_helpers.php:17) */
export function janusTriggerDepth(env: PortEnv): number | bigint {
    return intval(env.globals.__janus_trigger_depth ?? 0);
}
/** PHP: janus_trigger_enter (includes/functions/janus/core/janus_trigger_depth_helpers.php:33) */
export function janusTriggerEnter(effect: Storage | null = null, env: PortEnv): null {
    env.globals.__janus_trigger_depth = phpAdd(BigInt(janusTriggerDepth(env)), 1n);
    const stack = env.globals.__janus_trigger_effect_stack ?? array();
    const next = stack instanceof PhpArray ? stack.copy() : new PhpArray(entries(stack));
    next.append(phpCopy(effect));
    env.globals.__janus_trigger_effect_stack = next;
    return null;
}
/** PHP: janus_trigger_exit (includes/functions/janus/core/janus_trigger_depth_helpers.php:39) */
export function janusTriggerExit(env: PortEnv): null {
    const depth = phpSubtract(BigInt(janusTriggerDepth(env)), 1n);
    env.globals.__janus_trigger_depth = depth < 0 ? 0 : depth;
    const stack = env.globals.__janus_trigger_effect_stack;
    if (isArray(stack)) {
        const next = array(...entries(stack));
        if (!empty(next)) next.delete(array_key_last(next));
        if (empty(next)) delete env.globals.__janus_trigger_effect_stack;
        else env.globals.__janus_trigger_effect_stack = array(...entries(next));
    }
    return null;
}
/** PHP: janus_trigger_effect_snapshot (includes/functions/janus/core/janus_trigger_depth_helpers.php:51) */
export function janusTriggerEffectSnapshot(env: ReadEnv): Storage | null {
    const stack = env.globals.__janus_trigger_effect_stack;
    if (!isArray(stack) || empty(stack)) return null;
    const key = array_key_last(stack);
    const effect = key === null ? null : get(stack, strval(key));
    if (!isArray(effect)) return null;
    const id = strval(env.deps.item_field(effect, 'item_id') ?? get(effect, 'item_id_used', 0) ?? '');
    const name = trim(strval(env.deps.item_field(effect, 'item_name') ?? ''));
    const type = trim(strval(env.deps.item_field(effect, 'item_type') ?? ''));
    if (!checkUuid(id) || name === '') return null;
    return array(['item_id', strtoupper(id)], ['item_name', [...name].slice(0, 80).join('')], ['item_type', [...type].slice(0, 48).join('')]);
}

/** PHP: {closure@67:284} (includes/functions/janus/core/janus_trigger_depth_helpers.php:67) */
export function closure67_284(value:string,limit:number):string {return Array.from(value).slice(0,limit<0?limit:limit).join('');}
